__turbopack_context__.v({
  "bottom": "styles-module-scss-module__o3QkFq__bottom",
  "breadcrumb_container": "styles-module-scss-module__o3QkFq__breadcrumb_container",
  "breadcrumbs": "styles-module-scss-module__o3QkFq__breadcrumbs",
  "calculator": "styles-module-scss-module__o3QkFq__calculator",
  "calculator_section": "styles-module-scss-module__o3QkFq__calculator_section",
  "copyright_section": "styles-module-scss-module__o3QkFq__copyright_section",
  "grid_container": "styles-module-scss-module__o3QkFq__grid_container",
  "left": "styles-module-scss-module__o3QkFq__left",
  "listing_courtesy_of": "styles-module-scss-module__o3QkFq__listing_courtesy_of",
  "page": "styles-module-scss-module__o3QkFq__page",
  "page_container": "styles-module-scss-module__o3QkFq__page_container",
  "right": "styles-module-scss-module__o3QkFq__right",
  "right_margin_top_600": "styles-module-scss-module__o3QkFq__right_margin_top_600",
  "section_header": "styles-module-scss-module__o3QkFq__section_header",
  "sticky_footer": "styles-module-scss-module__o3QkFq__sticky_footer",
  "top_content_container": "styles-module-scss-module__o3QkFq__top_content_container",
});
